import { render, staticRenderFns } from "./DesignerPreview.vue?vue&type=template&id=13052925&scoped=true&"
import script from "./DesignerPreview.vue?vue&type=script&lang=js&"
export * from "./DesignerPreview.vue?vue&type=script&lang=js&"
import style0 from "./DesignerPreview.vue?vue&type=style&index=0&id=13052925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13052925",
  null
  
)

export default component.exports